export enum Market {
  SE = 'SE',
  DK = 'DK',
  DE = 'DE',
  AT = 'AT',
  NO = 'NO',
  FI = 'FI',
}
